import React, { useContext, useEffect, useState } from 'react'
import SidebarContext from '../../contexts/MyContext';
import RecordWithNotes from '../Notes/RecordWithNotes';

// The Record new tab uses the same recorder as AI Tools > My Notes.
const NewRecording = () => {
    const { setTabIndex, setFilterAudioData, autoStartRecording, setAutoStartRecording, recordingFolderId, setRecordingFolderId } = useContext(SidebarContext);
    // Read once, since the flag is cleared as soon as the tab opens.
    const [autoStart] = useState(!!autoStartRecording);
    const [folderId] = useState(recordingFolderId);

    useEffect(() => {
        if (autoStartRecording) setAutoStartRecording(false);
        if (recordingFolderId) setRecordingFolderId(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSaved = (savedAudio) => {
        setFilterAudioData((prevFilterAudioData) => [...prevFilterAudioData, savedAudio]);
        setTabIndex(folderId || 2);
    };

    return (
        <div className="nt">
            <RecordWithNotes autoStart={autoStart} folderId={folderId} onSaved={handleSaved} />
        </div>
    );
}

export default NewRecording
